<template>
    <div>
        <b-modal
            ref="modalEdit"
            hide-footer
            :title="titleModal"
            size="lg"
            no-close-on-backdrop
            hide-header-close
            hide-header
            >
        <div class="title-modal">
        <div class="title-text-modal">{{ titleModal }}</div>
        <div
            class="float-right btn-hover-modal"
            @click="closeModal()"
        >
            <xIcon/>
        </div>
        </div>
        <div class="modal-edicao mb-5 modal-edicao-label mt-6">
        <b-row class="mt-3 filters-orientation">
        <b-col class="text-parcela">
            <span class="label-conta">CPF/CNPJ</span>
            <b-form-input
                name="identityDocument"
                class="modal-edicao-input"
                type="text"
                v-model="customerSelected.identityDocument"
                autocomplete="off"
                placeholder="Digite o CPF/CNPJ"
                v-validate="'validateCPF'"
                :state="validateState('identityDocument')"
                @blur="formatDocumentSelected()"
            />
        </b-col>
        <b-col class="text-parcela">
            <span class="label-conta">Nome</span>
            <b-form-input
                name="name"
                class="modal-edicao-input"
                type="text"
                v-model="customerSelected.name"
                autocomplete="off"
                placeholder="Digite o seu nome"
                v-validate="'required|maxLength:50'"
                :state="validateState('name')"
            />
        </b-col>
        <b-col class="text-parcela">
            <span class="label-conta">Sobrenome</span>
            <b-form-input
                name="surname"
                class="modal-edicao-input"
                type="text"
                v-model="customerSelected.surname"
                autocomplete="off"
                placeholder="Digite o seu sobrenome"
                v-validate="'maxLength:50'"
                :state="validateState('surname')"
            />
        </b-col>
        </b-row>
        <b-row class="mt-3 filters-orientation">
        <b-col class="text-parcela">
            <span class="label-conta">CEP</span>
            <b-form-input
                name="zipCode"
                class="modal-edicao-input"
                type="text"
                v-model="customerSelected.zipCode"
                autocomplete="off"
                placeholder="Digite o CEP"
                v-validate="'maxLength:20'"
                :state="validateState('zipCode')"
            />
        </b-col>
        <b-col class="text-parcela">
            <span class="label-conta">Endereço</span>
            <b-form-input
                name="address"
                class="modal-edicao-input"
                type="text"
                v-model="customerSelected.address"
                autocomplete="off"
                placeholder="Digite o endereço"
                v-validate="'maxLength:100'"
                :state="validateState('address')"
            />
        </b-col>
        <b-col class="text-parcela">
            <span class="label-conta">Bairro</span>
            <b-form-input
                name="neighborhood"
                class="modal-edicao-input"
                type="text"
                v-model="customerSelected.neighborhood"
                autocomplete="off"
                placeholder="Digite o bairro"
                v-validate="'maxLength:50'"
                :state="validateState('neighborhood')"
            />
        </b-col>
        </b-row>
        <b-row class="mt-3 filters-orientation">
        <b-col class="text-parcela">
            <span class="label-conta">Cidade</span>
            <b-form-input
                name="city"
                class="modal-edicao-input"
                type="text"
                v-model="customerSelected.city"
                autocomplete="off"
                placeholder="Digite a cidade"
                v-validate="'maxLength:50'"
                :state="validateState('city')"
            />
        </b-col>
        <b-col class="text-parcela">
            <span class="label-conta">Estado</span>
            <b-form-input
                name="state"
                class="modal-edicao-input"
                type="text"
                v-model="customerSelected.state"
                autocomplete="off"
                placeholder="Digite o estado"
                v-validate="'maxLength:50'"
                :state="validateState('state')"
            />
        </b-col>
        <b-col class="text-parcela">
            <span class="label-conta">Pais</span>
            <b-form-input
                name="country"
                class="modal-edicao-input"
                type="text"
                v-model="customerSelected.country"
                autocomplete="off"
                placeholder="Digite o pais"
                v-validate="'maxLength:50'"
                :state="validateState('country')"
            />
        </b-col>
        </b-row>
        <b-row class="mt-3 filters-orientation">
        <b-col class="text-parcela">
            <span class="label-conta">E-mail</span>
            <b-form-input
                name="email"
                class="modal-edicao-input"
                type="text"
                v-model="customerSelected.email"
                autocomplete="off"
                placeholder="Digite o seu e-mail"
                v-validate="'maxLength:50'"
                :state="validateState('email')"
            />
        </b-col>
        <b-col class="text-parcela">
            <span class="label-conta">Celular</span>
            <b-form-input
                name="cellPhone"
                class="modal-edicao-input"
                type="text"
                v-model="customerSelected.cellPhone"
                autocomplete="off"
                placeholder="Digite número de celular"
                v-validate="'maxLength:50'"
                :state="validateState('cellPhone')"
            />
        </b-col>
        <b-col class="text-parcela">
            <span class="label-conta">Telefone</span>
            <b-form-input
                name="telephone"
                class="modal-edicao-input"
                type="text"
                v-model="customerSelected.telephone"
                autocomplete="off"
                placeholder="Digite número de telefone"
                v-validate="'maxLength:50'"
                :state="validateState('telephone')"
            />
        </b-col>
        </b-row>
        </div>
        <b-button class="ml-1 mt-5 float-left btn-modal btn-cancel" @click="closeModal()">Cancelar</b-button>
        <b-button class="mt-5 float-left btn-modal btn-limpar" @click="cleanModal()">Limpar</b-button>
        <b-button
        class="mt-5 mr-1 float-right btn-modal btn-salvar"
        @click="saveRecord"
        :disabled="invalidForm || saving"
        >
        Salvar
        </b-button>
        </b-modal>
    </div>
</template>

<script>
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { formatIdentityDocument } from "@/helpers/validateIndentity";
	import { CustomerService } from "@/services/customer";
	import emitter from "@/eventBus.js";
	import { mapState } from "vuex";

	export default {
		components: {

		},

		props: {
			customerData: {
				type: Object,
				required: false
			},
			name: {
				type: String,
				required: false
			}
		},

		inject: ["parentValidator"],

		data () {
			return {
				formatIdentityDocument,
				customerService: new CustomerService(),
				titleModal: "",
				loading: true,
				noEditCustomer: false,
				customerSelected: {
					name: "",
					surname: "",
					identityDocument: "",
					address: "",
					neighborhood: "",
					zipCode: "",
					city: "",
					state: "",
					country: "",
					cellPhone: "",
					telephone: "",
					email: ""
				},
				invalidForm: true,
				saving: false

			};
		},

		computed: mapState(["customer"]),

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);
			this.showCustomer();
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},
			showCustomer () {
				this.invalidForm = true;
				const {
					idCustomer = null,
					name = null,
					surname = null,
					identityDocument = null,
					address = null,
					neighborhood = null,
					zipCode = null,
					city = null,
					state = null,
					country = null,
					cellPhone = null,
					telephone = null,
					email = null
				} = this.customerData;

				if (!idCustomer) {

					this.customerSelected.name = this.name;
					this.titleModal = "Cadastrar Novo Cliente";
					this.noEditCustomer = true;
				} else {
					this.customerSelected.name = name;
					this.titleModal = "Editar Cliente";
					this.noEditCustomer = false;
				}

				this.customerSelected.idCustomer = idCustomer;
				this.customerSelected.surname = surname;
				this.customerSelected.identityDocument = this.formatIdentityDocument(identityDocument);
				this.customerSelected.address = address;
				this.customerSelected.neighborhood = neighborhood;
				this.customerSelected.zipCode = zipCode;
				this.customerSelected.city = city;
				this.customerSelected.state = state;
				this.customerSelected.country = country;
				this.customerSelected.cellPhone = cellPhone;
				this.customerSelected.telephone = telephone;
				this.customerSelected.email = email;
				this.$refs.modalEdit.show();
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			closeModal () {
				this.$refs.modalEdit.hide();
				this.cleanModal();
				this.customerSelected.idCustomer = "";
				this.saving = false;
				this.invalidForm = true;
				this.$emit("closeModal");
			},

			cleanModal () {
				this.customerSelected.name = "";
				this.customerSelected.surname = "";
				this.customerSelected.identityDocument = "";
				this.customerSelected.address = "";
				this.customerSelected.neighborhood = "";
				this.customerSelected.zipCode = "";
				this.customerSelected.city = "";
				this.customerSelected.state = "";
				this.customerSelected.country = "";
				this.customerSelected.cellPhone = "";
				this.customerSelected.telephone = "";
				this.customerSelected.email = "";
				this.invalidForm = true;
			},

			async saveRecord () {
				const invalidFields = await this.validateModal();
				if (invalidFields) {
					await this.$swal({
						title: "Formulário Inválido",
						text: "Existe informação sem preencher!",
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						confirmButtonText: "OK",
						reverseButtons: true
					});
					return;
				}

				if (await this.recordExist()) {
					return;
				}

				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				const payload = {
					name: this.customerSelected.name || "",
					surname: this.customerSelected.surname || "",
					identityDocument: this.customerSelected.identityDocument || "",
					address: this.customerSelected.address || "",
					neighborhood: this.customerSelected.neighborhood || "",
					zipCode: this.customerSelected.zipCode || "",
					city: this.customerSelected.city || "",
					state: this.customerSelected.state || "",
					country: this.customerSelected.country || "",
					cellPhone: this.customerSelected.cellPhone || "",
					telephone: this.customerSelected.telephone || "",
					email: this.customerSelected.email || ""
				};
				if (this.customerSelected.idCustomer)
					payload.idCustomer = this.customerSelected.idCustomer;

				this.$snotify.async("Aguarde...", "Salvando", async () => {
					try {
						this.saving = true;
						const newCustomer = await this.customerService.upsertCustomer({payload});

						this.$emit("findCustomer", true);
						this.$emit("newCustomer", newCustomer);
						emitter.emit("reloadCustomer", { reload: true });
						this.closeModal();

						return {
							title: "Sucesso!",
							body: "Cliente salvo com sucesso.",
							config
						};
					} catch (error) {
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar salvar cliente!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			async validateModal () {
				const validationFields = Object.keys(this.veeFields);
				if (!validationFields.length)
					return true;

				const validations = validationFields.reduce((acc, ref) => {
					if (this.veeFields[ref] && this.veeFields[ref].invalid)
						return [...acc, this.veeFields[ref].invalid];

					return acc;
				}, []);

				const invalidFields = validations.filter(field => field);
				return Boolean(invalidFields && invalidFields.length);
			},

			formatDocumentSelected () {
				this.customerSelected.identityDocument = formatIdentityDocument(this.customerSelected.identityDocument);
			},

			async recordExist () {
				const description = `${this.customerSelected.name} ${this.customerSelected.surname}`;
				const recordExistDescription = this.customer.find(c => c.description === description && (c.value !== this.customerSelected.idCustomer || description == null));
				const recordExistIdentity = this.customer.find(c => c.identityDocument === this.customerSelected.identityDocument && (c.value !== this.customerSelected.idCustomer || this.customerSelected.identityDocument == null));
				const identityEmpty = Boolean(!this.customerSelected.identityDocument);

				if ((recordExistDescription && identityEmpty) || recordExistIdentity) {
					await this.$swal({
						title: "Registro já existe",
						text: "Não é possível criar o registro, altere os dados e tente novamente.",
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						confirmButtonText: "OK",
						reverseButtons: true
					});
					return true;
				}

				return false;
			}
		}
	};
</script>
